export default __webpack_public_path__ + "static/media/image4.0054dae8.png";